var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSavedSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 16,
    viewBox: "0 0 20.001 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_1",
    "data-name": "Differenzmenge 1",
    d: "M-5320-98h-16a2,2,0,0,1-2-2l.011-12a2,2,0,0,1,1.989-2h6l2,2h8a2,2,0,0,1,2,2v10A2,2,0,0,1-5320-98Zm-6.863-4.6h0l2.6,2.594,1.266-1.266-2.595-2.587a3.963,3.963,0,0,0,.623-2.133,4.018,4.018,0,0,0-4.014-4.014,4.018,4.018,0,0,0-4.014,4.014,4.015,4.015,0,0,0,4.005,4.015,3.956,3.956,0,0,0,2.131-.624Zm-2.123-1.16a2.233,2.233,0,0,1-2.23-2.231,2.233,2.233,0,0,1,2.23-2.231,2.233,2.233,0,0,1,2.23,2.231A2.233,2.233,0,0,1-5328.986-103.755Z",
    transform: "translate(5338 114)",
    fill: "#006b87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSavedSearch);
export default __webpack_public_path__ + "static/media/Icon_SavedSearch.90f2b1611b687d33dd8065b57622d53f.svg";
export { ForwardRef as ReactComponent };